module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-statuses"
  }, [(_vm.statuses && _vm.statusTypes) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('div', {
      key: status.uuid,
      staticClass: "project-status"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(status.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_c('b', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("Vælg type:")]), _vm._v("\n                  \n                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.type.uuid),
        expression: "status.type.uuid"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(status.type, "uuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.update(status, $event)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("- Ingen type -")]), _vm._v(" "), _vm._l((_vm.statusTypes), function(statusType) {
      return _c('option', {
        key: statusType.uuid,
        domProps: {
          "value": statusType.uuid
        }
      }, [_vm._v("\n                        " + _vm._s(statusType.name) + "\n                    ")])
    })], 2)])])
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74a30572", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74a30572"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/projectStatuses.vue
// module id = 861
// module chunks = 0